"use client"

import {
  type LucideIcon,
} from "lucide-react"

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar
} from "@/components/ui/sidebar"
import Link from 'next/link'

import { useTranslation } from "react-i18next"

export function NavCommunity({
  items,
}: {
  items: {
    name: string
    url: string
    icon: LucideIcon,
    isActive?: boolean
  }[]
}) {
  const { t } = useTranslation()
  const { setOpenMobile } = useSidebar()

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Community</SidebarGroupLabel>
      <SidebarMenu>
        {items.map((item) => (
          <SidebarMenuItem key={item.name}>
            <SidebarMenuButton isActive={item.isActive} tooltip={item.name} asChild>
              <Link href={item.url} onClick={() => { setOpenMobile(false) }}>
                {item.icon && <item.icon strokeWidth={item.isActive ? 3 : 2} />}
                <span className={item.isActive ? "font-bold" : "font-normal"}>{t(item.name)}</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )
}
